module.exports = __webpack_public_path__ + "static/media/comment-alt-shield.2fe35aa8.svg";